export const AppealConfigModeMap = {
    /**
     * 申述有效期
     */
    Validity: 1,
    /**
     * 申述截至时间
     */
    CutOff: 2,
};

/** 抽检有效期方式：不设置 / 设置抽检有效期 / 设置抽检截止时间 */
export const SamplePeriodModeMap = {
    /** 不设置有效期（默认） */
    None: 0,
    /** 设置抽检有效期 */
    SAMPLE_PERIOD: 1,
    /** 设置抽检截止时间 */
    SAMPLE_DEADLINE: 2,
};

